<template>
  <div>
    <div v-if="couponList.length" class="ready">
      <v-container>
        <div class="info-block">
          <!-- 商品資訊 -->
          <div class="product-area">
            <div class="product-img">
              <img onerror="this.className= 'none';" :src="order.imageUrl" />
              <div class="none-img"></div>
            </div>
            <div class="product-info">
              <h1>{{ order.productName }}</h1>
              <div v-show="order.isGroupCoupon" class="product-type">
                成套票券
              </div>
              <div v-if="!isGoods" class="product-expire">
                有效期限：{{ order.usingEndTime | formatDateTime('YYYY/MM/DD') }}
              </div>
            </div>
          </div>
          <div class="hr"></div>
          <div class="coupon-counter">
            <div class="cupon-control" v-if="couponType == 8 && couponList.length">
              <div
                v-if="isVarious"
                :class="[{ disabled: currentCoupon == 0 }]"
                class="prev"
                @click="changeTicket(0)"
              >
                <img src="@/assets/img/arrow-point-to-left.svg" />
              </div>
              <div
                v-if="isVarious"
                :class="[{ disabled: currentCoupon == total }]"
                class="next"
                @click="changeTicket(1)"
              >
                <img src="@/assets/img/arrow-point-to-right.svg" />
              </div>
            </div>
            {{ currentCoupon + 1 }} / {{ total }}
          </div>
          <!-- type8 開啟URL -->
          <div v-if="couponType == 8 && couponList.length" class="outer-url" style="margin: 0px -16px;">
            <iframe
              v-for="(coupon, index) in couponList"
              v-show="currentCoupon == index"
              :key="'url' + index"
              :src="coupon.url"
              ref="iframe"
              frameborder="0"
            ></iframe>
          </div>
          <div v-else class="self-code">
            <!-- type9 QR code -->
            <div v-if="couponType == 9 || couponType == 0" class="qr-code">
              <qrcode
                v-show="showCode"
                :value="couponList[currentCoupon].qrCode"
                :options="{ width: 202 }"
              />
              <div>{{ couponList[currentCoupon].qrCode }}</div>
            </div>
            <!-- type5 雙條碼-->
            <div v-else-if="couponType == 5 && showCode" class="barcode-2">
              <barcode
                :value="couponList[currentCoupon].barcode2"
                :options="{
                  format: 'CODE128',
                }"
                tag="img"
              />
              <barcode
                :value="couponList[currentCoupon].barcode1"
                :options="{
                  format: 'CODE39',
                }"
                tag="img"
              />
            </div>
            <!-- 全家條碼-->
            <div v-else-if="couponType == 6 && showCode" class="barcode">
              <barcode
                :value="couponList[currentCoupon].barcode1"
                :options="{
                  format: 'CODE39',
                  height: 200
                }"
                tag="img"
              />
            </div>
            <!-- 單一條碼-->
            <div v-else-if="showCode" class="barcode">
              <barcode
                :value="couponList[currentCoupon].barcode1"
                :options="{
                  format: barcodeTable[couponType],
                }"
                tag="img"
              />
            </div>
            <div class="cupon-control">
              <div
                v-if="isVarious"
                :class="[{ disabled: currentCoupon == 0 }]"
                class="prev"
                @click="changeTicket(0)"
              >
                <img src="@/assets/img/arrow-point-to-left.svg" />
              </div>
              <div
                v-if="isVarious"
                :class="[{ disabled: currentCoupon == total }]"
                class="next"
                @click="changeTicket(1)"
              >
                <img src="@/assets/img/arrow-point-to-right.svg" />
              </div>
            </div>
          </div>
          <div
            v-if="(couponType == 6 || couponType == 7) && couponList[currentCoupon].pincode1"
            class="pincode mt-3"
          >
            紅利PIN碼：{{ couponList[currentCoupon].pincode1 }}
          </div>
          <div class="justify-center d-flex py-4" v-if="couponType !== 8">
            <v-btn
              class="btn-copy"
              color="#1ea7fc"
              height="48"
              v-clipboard:copy="couponList[currentCoupon].barcode1"
              v-clipboard:success="onCopy"
            >
              複製序號
            </v-btn>
            <div class="copy-success-div" v-show="copySuccess">{{ copiedData }}</div>
          </div>
          <div v-if="couponList[currentCoupon].status" class="history">
            {{ couponList[currentCoupon].verifiedTime }} 兌換完成
          </div>
          <div v-if="couponList[currentCoupon].note" class="note">
            {{ couponList[currentCoupon].note }}
          </div>
        </div>
      </v-container>
    </div>
    <!-- codeType:
    1.Barcode128
    2.Barcode EAN13
    3,4. Bardcode39
    5. code39 二段條碼 先用barcode2再來 barcode1
    6. 全家CODE39 一段
    7. 萊爾富CODE39 一段
    8. 開啟URL
    9. QRCode -->
  </div>
</template>
<script>
import VueBarcode from '@chenfengyuan/vue-barcode'
export default {
  name: 'RedeemPage',
  components: {
    barcode: VueBarcode,
  },
  data: function() {
    return {
      barcodeTable: {
        1: 'CODE128',
        2: 'EAN13',
        3: 'CODE39',
        4: 'CODE39',
        6: 'CODE39',
        7: 'CODE39',
      },
      couponType: 0,
      isVarious: 0,
      orderId: '',
      newOrderNo: '',
      couponList: [],
      currentCoupon: 0,
      total: 0,
      order: '',
      copySuccess: false,
      copiedData: ''
    }
  },
  created: function() {
    this.orderId = this.$route.query.oid
    this.isVarious = this.$route.params.amount > 1
    this.total = this.$route.params.amount || 1
    this.newOrderNo = this.$route.query.nOid
    this.getOrderDetail()
    this.getCouponCode()
  },
  methods: {
    getCouponCode() {
      api
        .getCouponQrCode(this.orderId, this.newOrderNo)
        .then(res => {
          if (res.data.length) {
            res.data.forEach(data => {
              if (!this.newOrderNo && data.status) return // 非贈禮時 已核銷票券不顯示
              this.couponType = data.codeType
              const coupon = data
              coupon.qrCode =
                data.sequenceNumber + (data.code ? '-' + data.code : '')
              this.couponList.push(coupon)
            })
          } else {
            this.$bus.$emit('callAllert', {
              messageContent: '查無資料',
              callback: () => {
                if (localStorage.getItem('source') === 'e7g') {
                  window.location = process.env.VUE_APP_E7G_HOME
                } else {
                  this.$router.replace({ name: 'home' })
                }
              },
            })
          }
        })
        .catch(err => {
          this.$router.replace('/error?errorCode=' + err.code || '0000')
        })
    },
    changeTicket(type) {
      if (type) {
        if (this.currentCoupon + 1 < this.total) {
          this.currentCoupon++
          // if (this.couponType == 8) {
          //   this.$refs.iframe.contentWindow.location.replace(
          //     this.couponList[this.currentCoupon].url
          //   )
          // }
        }
      } else {
        if (this.currentCoupon > 0) {
          this.currentCoupon--
          // if (this.couponType == 8) {
          //   this.$refs.iframe.contentWindow.location.replace(
          //     this.couponList[this.currentCoupon].url
          //   )
          // }
        }
      }
    },
    getOrderDetail() {
      api
        .getOrderDetail(
          this.orderId,
          this.newOrderNo,
        ).then(res => {
          this.order = res.data
          console.log(this.order)
        }).catch(err => {
          console.log(err)
          this.$bus.$emit('callAllert', {
            messageContent: '查無資料',
            callback: () => {
              if (localStorage.getItem('source') === 'e7g') {
                window.location = process.env.VUE_APP_E7G_HOME
              } else {
                this.$router.replace({ name: 'home' })
              }
            },
          })
        })
    },
    onCopy() {
      this.copySuccess = true
      this.copiedData = '複製成功'
      window.setInterval(() => (this.copySuccess = false), 3000)
    },
  },
  computed: {
    showCode() {
      return !this.newOrderNo || !this.couponList[this.currentCoupon].status
    },
  },
}
</script>

<style lang="scss" scoped>
.outer-url {
  iframe {
    height: calc(100vh - 118px) !important;
    overflow-x: hidden;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
}
.self-code {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  .qr-code {
    // padding: 0 4.8%;
    word-break: break-all;
  }
  .barcode-2,
  .barcode {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding: 0 10%;
    img {
      max-width: 100%;
      ~ img {
        height: 40%;
      }
    }
  }
  ::v-deep .vue-barcode-element {
    max-height: 70vh;
  }
  .text {
    font-size: 15px;
    font-weight: bold;
    color: #222;
    margin: 0 10px;
  }
  .history {
    padding-top: 8px;
    font-size: 13px;
    color: #4a4a4a;
  }
}
.prev,
.next {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: 100%;
  }
}
.type-8 {
  .prev,
  .next {
    position: absolute;
    top: 35vh;
    width: 56px;
    height: 56px;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
    }
  }
  .prev {
    left: 0;
    border-radius: 0 100% 100% 0;
  }
  .next {
    right: 0;
    border-radius: 100% 0 0 100%;
  }
}
.back-btn {
  padding: 0 4.8%;
}
.fixed-bottom {
  background-color: #fff;
  width: 100%;
  position: fixed;
  bottom: 0;
  .label {
    text-align: center;
  }
}
.self-code ~ .fixed-bottom {
  position: relative;
}

.container {
  background-color: #f3f5f8;
  padding: 16px;
  min-height: 100vh;
}

.info-block {
  background-color: #ffffff;
  border-radius: 16px;
  padding: 24px 16px;
}

.product-area {
  display: flex;
  margin-bottom: 24px;
  .product-img {
    flex: 2;
    margin-right: 16px;
    img {
      width: 100%;
      border-radius: 16px;
    }
  }
  .product-info {
    flex: 5;
    h1 {
      font-size: 16px;
      font-weight: 600;
      color: #2a2b2b;
    }
    .product-type {
      font-size: 10px;
      padding: 0px 8px;
      color: #fff;
      background-color: #ffbf56;
      border-radius: 30px;
      display: inline-block;
      line-height: 18px;
    }
    .product-expire {
      color: #8e9091;
      font-size: 14px;
    }
  }
}

.hr {
  background-color: #d9dbde;
  height: 2px;
  width: 100%;
  margin-bottom: 40px;
}

.coupon-counter {
  text-align: center;
  font-size: 16px;
  color: #2a2b2b;
  font-weight: 600;
  margin-bottom: 8px;
  position: relative;
}

.pincode {
  text-align: center;
  font-size: 14px;
  color: #2a2b2b;
}

.cupon-control {
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  .prev, .next {
    width: 16px;
    height: 16px;
  }
}

.note {
  color: #8e9091;
  margin-top: 48px;
  font-size: 14px;
  line-height: 1.57;
}

.btn-copy {
  border-radius: 8px;
  box-shadow: none;
  min-width: 100% !important;
  ::v-deep .v-btn__content {
    font-size: 16px;
    letter-spacing: 0;
    color: #fff;
    font-weight: 700;
  }
}

.copy-success-div {
  position: fixed;
  color: #fff;
  top: 50%;
  left: 50%;
  min-height: 50px;
  width: 80%;
  text-align: center;
  line-height: 50px;
  border-radius: 5px;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  opacity: 0.7;
  background-color: #000;
}
</style>
